import styled from 'styled-components';
import { theme } from '_constants/theme';
import { config } from '_config';
const { colors, devices, fontSizes, spaces } = theme;

const StyledSearchToUseUSPTOSection = styled.div`
  max-width: 1400px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 100px;
  @media ${devices.tablet} {
    padding-top: 20px;
  }
`;
const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  @media ${devices.tablet} {
    flex-direction: column;
    gap: 10px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;
const StyledContainerColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  p {
    color: #03589c;
    width: 100%;
    font-family: 'MontserratRegular';
    font-style: normal;
    font-size: ${fontSizes.regular}px;
    line-height: 18px;
    text-align: left;
  }
  img {
    max-width: 200px;
  }
`;
const StyledSeparator = styled.div`
  background: #dee0e8;
  width: 1px;
`;
const StyledHeader = styled.div`
  color: #f37217;
  font-family: 'MontserratRegular';
  font-style: normal;
  font-size: ${fontSizes.large}px;
  width: 100%;
  margin-bottom: 1rem;
  @media ${devices.tablet} {
    margin-bottom: 0px;
  }
`;
const StyledItem = styled.div`
  display: flex;
  gap: 20px;
  img {
    max-width: 118px;
  }
  color: #03589c;
  width: 100%;
  font-family: 'MontserratRegular';
  font-style: normal;
  font-size: ${fontSizes.regular}px;
  line-height: 18px;
  text-align: left;
  align-items: center;
`;
const items = [
  {
    image: `${config.basePath}/step-process-3.png`,
    text: "Start by searching for the exact word or key phrase you’d like to trademark. Be sure to try several variations of your search to thoroughly exhaust all potential search options. It's crucial to note that a search in this database doesn't guarantee automatic rights to the trademark.",
  },
  {
    image: `${config.basePath}/step-process-2.png`,
    text: "There might be trademarks that exist but haven't been formally registered with the USPTO. Conducting a meticulous search before initiating your application not only safeguards your investment but also prevents costly errors down the road. Once a trademark application is submitted, any changes become off-limits, and fees are nonrefundable if your application gets rejected.",
  },
  {
    image: `${config.basePath}/step-process-1.png`,
    text: 'Running searches using this search does not mean you’ll automatically get rights to the trademark, as some trademarks may exist that have not been registered with the United States Patent and Trademark Office. Performing a search before you begin the application process is important to help save you money and avoid expensive errors. After a trademark application has been completed, changes cannot be made and fees are not refunded if your application is rejected. ',
  },
  {
    image: `${config.basePath}/faq-lockup.png`,
    text: 'Once you’ve determined the eligibility of your intended trademark, it’s time to move on to the next step of the trademark application process.',
  },
];
const SearchToUseUSPTOSection = () => {
  return (
    <StyledSearchToUseUSPTOSection>
      <StyledContainer>
        <StyledContainerColumn>
          <StyledHeader>To use the USPTO database</StyledHeader>
          {items.map((item, j) => (
            <StyledItem>
              <img src={item.image} alt="" layout="fill" />
              {item.text}
            </StyledItem>
          ))}
        </StyledContainerColumn>
        <StyledSeparator />
        <StyledContainerColumn>
          <StyledHeader>Reasons to File A Trademark Application</StyledHeader>
          <p>
            Filing for a trademark gives you as an owner the exclusive rights to
            use your mark for your goods or service. In turn, you’ll make a
            smart move in protecting your brand’s identity. Regardless if you’re
            a new or existing business, a trademark can be a powerful tool in
            helping to set your brand apart from others.
          </p>
          <p>
            Filing a trademark application helps to establish your brand’s
            identity, making a promise to your customers. If another company
            attempts to use a similar name or logo as yours, you’ll have legal
            documentation in order to challenge them in court. Furthermore, a
            trademark serves to help customers recognize your brand, reducing
            the likelihood of customer confusion.
          </p>
          <p>
            Should you sell your business, a trademark may also enhance your
            business value. This valuable asset may assist you in the sale of
            your company.
          </p>
          <img src={`${config.basePath}/protect-1.png`} alt="" layout="fill" />
        </StyledContainerColumn>
      </StyledContainer>
    </StyledSearchToUseUSPTOSection>
  );
};

export default SearchToUseUSPTOSection;
